import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

function ScreeningsSuccess() {
  const { state } = useLocation();

  return (
    <div className="text-center" style={{ padding: '2em' }}>
      <h2 className="text-xl font-bold">
        <FormattedMessage id="/gx5bs" description="success" defaultMessage="Success !"/>
      </h2>
      <p className="mb-4">
        <FormattedMessage id="x9J1KD" description="screenings-social-needs" defaultMessage="We got your social needs screening."/>
      </p>
      <p className="mx-auto col-md-4 border border-solid rounded border-dark-border-blue p-4 mb-8 bg-dark-fill-blue">
        <h2 className="text-xl font-bold mb-4"> 
          <FormattedMessage id="fB/+5s" description="screening-next-step" defaultMessage="Next Steps"/>
        </h2>
        <FormattedMessage id="3XEG9V" description="screening-success-message" defaultMessage="We're reviewing your responses and will reach out in the next few business days to discuss available services. If you have any questions or concerns before then, feel free to contact us."/>
      </p>
    </div>
  );
}

export default ScreeningsSuccess;
